import React from 'react';

const LeftTitleWithField = ({title, children}) => (
  <div className="form-group row">
    <label className="col-3 col-lg-4 col-md-4 col-form-label text-left">
      {title && title}
    </label>
    <div className="col-9 col-lg-8 col-md-8 align-items-center align-content-center">
      {children && children}
    </div>
  </div>
);

export default LeftTitleWithField;
